import appController from './app.controller';
import appTemplate from './app.html';

export default {
  bindings: {},
  controller: appController,
  controllerAs: 'app',
  template: appTemplate
};



// WEBPACK FOOTER //
// ./src/app/app.component.js